import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=caafb3f2&"
import script from "./Customer.vue?vue&type=script&lang=ts&"
export * from "./Customer.vue?vue&type=script&lang=ts&"
import style0 from "./Customer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports